import script from "./DataProcessing.vue?vue&type=script&setup=true&lang=ts"
export * from "./DataProcessing.vue?vue&type=script&setup=true&lang=ts"

import "./DataProcessing.vue?vue&type=style&index=0&id=50f3d80a&lang=css"
import "./DataProcessing.vue?vue&type=style&index=1&id=50f3d80a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50f3d80a"]])

export default __exports__